export default function getAuthConfig() {
    const domain = window.document.domain;
    switch (domain) {
        case 'localhost': // Local
            return {
                domain: "dev-zxiqyn1x.us.auth0.com",
                clientId: 'OMU1GVi4Z3xCjTdYpQNgjlUqs3GFDxCg'
            };
        case 'develop.yggdrasil-1jy.pages.dev': // Dev
            return {
                domain: "qa-zxiqyn1x.us.auth0.com",
                clientId: 'W1hTqMJCcQbsS06q1iEcXUzhbAfs6c6s'
            };
        case 'yggdrasil-1jy.pages.dev': // Prod
            return {
                domain: "zxiqyn1x.us.auth0.com",
                clientId: '2bcNpvuv6pRFN4f6lslYNKPeoWVQzFzV'
            };
        default:
            throw new Error('Unsupported environment');
    }
}
